module.exports = __webpack_public_path__ + "static/media/4-review-us-image.9c6e9cbc.png";